import React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { EnrollButtons } from "@/components/EnrollButtons";

const faqs = [
  { q: "How are the classes conducted?", a: "All classes are taken live on Zoom, so you can join from anywhere using your phone or laptop." },
  { q: "What are the batch timings?", a: "Sessions mostly happen on weekends, so they fit around work or college. We also hold a few live market sessions where we trade and analyse charts together while the market is open." },
  { q: "How long is the course?", a: "The complete course runs for 1 month and covers all 5 modules, from the basics to risk management and trading psychology." },
  { q: "How will my doubts be solved?", a: "You can message the mentor directly on WhatsApp with any doubt, whether it's about a chart, a setup or a trade." },
  { q: "How do I enroll?", a: "Tap \"Enroll on WhatsApp\" or call us. We'll share the next batch dates and payment details with you." },
];

export const FAQ = () => (
  <section id="faq" className="max-w-7xl mx-auto px-6 lg:px-10 py-24 grid lg:grid-cols-12 gap-10 scroll-mt-20">
    <div className="lg:col-span-4 space-y-5">
      <div className="tracking-overline text-[10px] text-fin-green">FAQ</div>
      <h2 className="font-display text-3xl md:text-4xl text-white">Questions before you join?</h2>
      <p className="text-white/60">Still unsure? Message us and we'll answer you personally.</p>
      <EnrollButtons id="faq" size="h-11" />
    </div>
    <Accordion type="single" collapsible className="lg:col-span-8 space-y-3">
      {faqs.map((f, i) => (
        <AccordionItem key={f.q} value={`f-${i}`} data-testid={`faq-${i + 1}`} className="border border-white/10 rounded-md bg-[#141414] px-6 data-[state=open]:border-fin-green/50 transition-colors">
          <AccordionTrigger data-testid={`faq-${i + 1}-toggle`} className="hover:no-underline text-left text-white font-semibold text-sm md:text-base py-5">
            {f.q}
          </AccordionTrigger>
          <AccordionContent className="text-white/70 text-sm leading-relaxed pb-5">{f.a}</AccordionContent>
        </AccordionItem>
      ))}
    </Accordion>
  </section>
);
